var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMacOsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 406.5899048 500"
    },
    viewBox: "0 0 406.5899048 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M393.794 170.505c-2.88 2.24-54.063 30.71-54.063 95.01 0 74.216 64.94 100.448 66.859 101.088-.32 1.92-10.237 35.828-34.23 71.017-21.112 30.71-43.825 61.74-77.734 61.74s-42.867-20.153-81.894-20.153c-38.388 0-51.823 20.793-82.854 20.793s-52.783-28.79-77.735-63.66C23.353 395.074 0 331.414 0 270.633c0-96.929 63.02-148.752 125.4-148.752 32.95 0 60.46 21.753 81.254 21.753 19.514 0 50.224-23.033 87.972-23.033 14.395 0 65.579 1.28 99.168 49.904zm-184.58-55.342c-2.56 0-5.12-.32-6.719-.64-.32-1.28-.96-5.118-.96-8.957 0-25.911 13.116-51.503 27.512-67.818C246.96 16.635 277.35.96 302.303 0c.64 2.88.96 6.398.96 9.917 0 25.592-10.877 51.183-26.232 69.738-16.634 20.473-45.105 35.508-67.818 35.508z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMacOsLogo);
export default __webpack_public_path__ + "static/media/macOS-logo.0009e5aef034835e5889b05f2665b695.svg";
export { ForwardRef as ReactComponent };